import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  data: {
    color: "#00003D",
    opacity: 1,
  },
}))

export default styles
